import React from 'react';
import Grid from "@material-ui/core/Grid";
import Chip from '@material-ui/core/Chip';
import { formatDateOnly } from '../../../common/functions';
import { useGlobalState } from '../../../state';
import EnergyTooltip from '../components/materialTypeComponents/EnergyTooltip';
import { minChipLabelMobile } from '../../../views/FeedFormulation/utils/constants';
import PPMobileCardView from '../../../components/PPMobileCardView';

const Mobile = ({data, viewDetails, onDelete, onEdit, onPaymentEdit, onGenerateInvoice, isProPlusVersion, amountObj}) => {
    const [{user}] = useGlobalState();

    function calculateTotalAmount (rowData) {
        if (isProPlusVersion) {
            let totalAmount = 0
            let gstAmount = 0
            let tdsAmount = 0
            let tcsAmount = 0
            let billValue = 0
            if (rowData && rowData.purchaseMaterials) {
                let purchaseMaterials = rowData.purchaseMaterials
                purchaseMaterials.forEach(purchaseMaterial => {
                    let gstTaxAmt = parseFloat((purchaseMaterial.billValue * (purchaseMaterial.gst ? purchaseMaterial.gst : 0) / 100).toFixed(2))
                    let tdsTaxAmt = parseFloat((purchaseMaterial.billValue * (rowData.tds ? rowData.tds : 0) / 100).toFixed(2))
                    let tcsTaxAmt = parseFloat((purchaseMaterial.billValue * (rowData.tcs ? rowData.tcs : 0) / 100).toFixed(2))
                    gstAmount += gstTaxAmt
                    tdsAmount += tdsTaxAmt
                    tcsAmount += tcsTaxAmt
                    billValue += purchaseMaterial.billValue
                })
            }
            let gstTCSVal = gstAmount * (rowData.tcs/100)
            let totalTCS = Math.ceil(tcsAmount + gstTCSVal)
            totalAmount = billValue + totalTCS + gstAmount - tdsAmount
            return totalAmount.toLocaleString(user.locales,amountObj)
        } else { // pro version
            return (rowData.billValue).toLocaleString(user.locales,amountObj)
        }
    }

    function calculateRemainingBalance(rowData) {
        let totalAmount = 0
        let gstAmount = 0
        let tdsAmount = 0
        let tcsAmount = 0
        let billValue = 0
        let totalAmountPaid = 0
        if (rowData && rowData.purchaseMaterials) {
            let purchaseMaterials = rowData.purchaseMaterials
            purchaseMaterials.forEach(purchaseMaterial => {
                let gstTaxAmt = parseFloat((purchaseMaterial.billValue * (purchaseMaterial.gst ? purchaseMaterial.gst : 0) / 100).toFixed(2))
                let tdsTaxAmt = parseFloat((purchaseMaterial.billValue * (rowData.tds ? rowData.tds : 0) / 100).toFixed(2))
                let tcsTaxAmt = parseFloat((purchaseMaterial.billValue * (rowData.tcs ? rowData.tcs : 0) / 100).toFixed(2))
                gstAmount += gstTaxAmt
                tdsAmount += tdsTaxAmt
                tcsAmount += tcsTaxAmt
                billValue += purchaseMaterial.billValue
            })
        }
        if (rowData && rowData.purchasePayments && rowData.purchasePayments.length) {
            let purchasePayments = rowData.purchasePayments
            purchasePayments.forEach(ele => {
                if (ele.paymentMode !== -1 ) { // Exclude tax payment
                    totalAmountPaid += ele.paymentAmount
                }
            })
        }
        let gstTCSVal = gstAmount * (rowData.tcs/100)
        let totalTCS = Math.ceil(tcsAmount + gstTCSVal)
        totalAmount = billValue + totalTCS + gstAmount - tdsAmount
        
        let remainingAmount = totalAmount - totalAmountPaid;

        if (rowData.paymentStatus === 2 && remainingAmount < 1) {
            remainingAmount = 0
        }

        return remainingAmount.toLocaleString(user.locales,amountObj)
    }

    function calculateBillValue(rowData) {
        let billValue = 0
        if (rowData && rowData.purchaseMaterials) {
            let purchaseMaterials = rowData.purchaseMaterials
            purchaseMaterials.forEach(purchaseMaterial => {
                billValue += purchaseMaterial.billValue
            })
        }
        return billValue.toLocaleString(user.locales,amountObj)
    }

    const rows = isProPlusVersion
        ? [
            { label: 'Customer', value: data.vendorName || 'N/A', fullWidth: true, hideLabel: true, bold: true, fontSize: 14 },
            { label: 'Total Amount', value: calculateTotalAmount(data) },
            { label: 'Bill Value', value: calculateBillValue(data) },
            { label: 'Remaining', value: calculateRemainingBalance(data) },
            { label: 'Payment', inHeader: true, hideLabel: true, value: (
                <Chip
                    label={data.paymentStatus === 0 ? "Not Paid" : data.paymentStatus === 1 ? "Partially Paid" : data.paymentStatus === 2 ? "Paid" : "Pending"}
                    // color={data.paymentStatus === 2 ? "primary" : data.paymentStatus === 1 ? "secondary" : "default"}
                    style={{
                        backgroundColor:
                            data.paymentStatus === 0 ? "#f44336" :
                            data.paymentStatus === 1 ? "#ffeb3b" :
                            data.paymentStatus === 2 ? "#4caf50" : undefined,
                        color: data.paymentStatus === 1 ? "#000" : "#fff",
                    }}
                    size="small"
                    className="pp-pill"
                />
            )},
        ]
        : [
            { label: 'Farm Name', value: data.farmName || 'N/A' },
            { label: 'Total Amount', value: calculateTotalAmount(data) },
        ];

    const menuItems = [
        viewDetails && { label: 'Details', onClick: viewDetails },
        onEdit && { label: 'Edit', onClick: onEdit },
        onPaymentEdit && { label: 'Payment', onClick: onPaymentEdit },
        onGenerateInvoice && { label: 'Generate Invoice', onClick: onGenerateInvoice },
        onDelete && { label: 'Delete', onClick: onDelete },
    ].filter(Boolean);

    return (
        <PPMobileCardView
            title={formatDateOnly(data.date, "DD/MM/YYYY")}
            id={data.billNumber || data.id}
            rows={rows}
            menuItems={menuItems}
            onClick={viewDetails}
        >
            {!isProPlusVersion && data?.purchaseMaterials?.length > 0 && (
                <div style={{ marginTop: 4 }}>
                    <div className="pp-card-label" style={{ marginBottom: 4 }}>Materials</div>
                    <Grid container spacing={1} wrap='nowrap'>
                        {data.purchaseMaterials.map((material, index) => {
                            if (index < minChipLabelMobile) {
                                return (
                                    <Grid item key={index}>
                                        <Chip label={material.materialName} color="primary" size='small' className="pp-pill" />
                                    </Grid>
                                )
                            }
                            return null;
                        })}
                        {data.purchaseMaterials.length > minChipLabelMobile && (
                            <EnergyTooltip
                                arrow={true}
                                title={
                                    <Grid container spacing={1}>
                                        {data.purchaseMaterials.map((material, index) => {
                                            if (index >= minChipLabelMobile) {
                                                return (
                                                    <Grid item key={index}>
                                                        <Chip label={material.materialName} color="primary" size='small' className="pp-pill" />
                                                    </Grid>
                                                )
                                            }
                                            return null;
                                        })}
                                    </Grid>
                                }
                            >
                                <Grid item>
                                    <Chip size="small" className="pp-pill" color="primary" label={`+ ${data.purchaseMaterials.length - minChipLabelMobile}`} />
                                </Grid>
                            </EnergyTooltip>
                        )}
                    </Grid>
                </div>
            )}
        </PPMobileCardView>
    );
};

export default Mobile;